/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { TerytSimcTo } from '../../models/teryt-simc-to';

export interface ApiWebTerytMiejscaGet$Params {
  date?: LocalDate;
  gmi?: string;
  pow?: string;
  q?: string;
  woj?: string;
}

export function apiWebTerytMiejscaGet(http: HttpClient, rootUrl: string, params?: ApiWebTerytMiejscaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytSimcTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebTerytMiejscaGet.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('gmi', params.gmi, {});
    rb.query('pow', params.pow, {});
    rb.query('q', params.q, {});
    rb.query('woj', params.woj, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TerytSimcTo>>;
    })
  );
}

apiWebTerytMiejscaGet.PATH = '/api/web/teryt/miejsca';
